import callAPI from 'api'
import { AddressPayload } from 'services/lead-address'

export interface Location {
  lat: number
  lng: number
}

export interface LocationBias {
  radius: number
  center: google.maps.LatLng
}

export interface AutocompleteOptions {
  region?: string
  language?: string // Default is "en"
  radius?: number // Default is 1000
  types?: Array<'geocode' | 'address' | 'establishment' | 'regions' | 'cities'>
}

export interface Prediction {
  formatted_address: string
  place_id: string
  description?: string
}

export interface CRMPlaceAutocompletePayload {
  input: string
  sessiontoken: string
  options?: AutocompleteOptions
}

export interface CRMPlaceDetailsPayload {
  place_id: string
}

export type PlaceDetailsResponse = {
  lat: number
  lng: number
  place_id: string
  formatted_address: string
  address_components:
    | string // support for previous implementation of use-places-autocomplete npm package
    | {
        types: string[]
        long_name: string
        short_name: string
      }[]
  mapped_address: AddressPayload
}

export const crmGetPlaceAutocomplete = async (payload: CRMPlaceAutocompletePayload) =>
  await callAPI<Prediction[], CRMPlaceAutocompletePayload>('crm_get_place_autocomplete', [payload], {
    requireAuthorization: true,
  })

export const crmGetPlaceDetails = async (payload: CRMPlaceDetailsPayload) =>
  await callAPI<PlaceDetailsResponse, CRMPlaceDetailsPayload>('crm_get_place_details', [payload], {
    requireAuthorization: true,
  })
